import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AliasProduct, AliasProductInput } from "../types/AliasProduct";
import { GET_ALIAS_PRODUCTS_FETCH_KEY } from "./useGetAliasProducts";

export const createAliasProduct = async (
  newAliasProduct: AliasProductInput,
): Promise<AliasProduct> => {
  try {
    const response = await fetcher.post(
      `${API.GESLUB}/alias-product`,
      newAliasProduct,
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error en la solicitud de creación de alias del producto",
      error,
    );
    throw error;
  }
};

export const useCreateAliasProduct = () => {
  const queryClient = useQueryClient();

  return useMutation<AliasProduct, Error, AliasProductInput>({
    mutationFn: createAliasProduct,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_ALIAS_PRODUCTS_FETCH_KEY],
      });
    },
    onError: (error) => {
      console.error("Error al crear el alias de product:", error);
    },
  });
};
